export const blogPosts = [
  {
    id: 1,
    title: "5 Tipps für effektives Training",
    excerpt: "Lernen Sie die wichtigsten Grundlagen für ein effektives Krafttraining kennen.",
    date: "2025-04-28",
    author: "Max Mustermann",
    content: `Ein effektives Krafttraining basiert auf mehreren wichtigen Grundprinzipien:

### 1. Progressive Überlastung
      Steigern Sie kontinuierlich die Belastung, um Fortschritte zu erzielen.
### 2. Korrekte Ausführung
      Achten Sie stets auf die richtige Technik bei allen Übungen.
### 3. Ausreichende Regeneration
      Gönnen Sie Ihrem Körper genügend Ruhe zwischen den Trainingseinheiten.
### 4. Ausgewogene Ernährung
      Versorgen Sie Ihren Körper mit allen wichtigen Nährstoffen.
### 5. Konstanz
      Der wichtigste von allen Punkten: Halten Sie sich an Ihren Trainingsplan und bleiben Sie motiviert.
      Setzen Sie sich realistische Ziele und verfolgen Sie Ihre Fortschritte.
      Trainieren Sie regelmäßig und bleiben Sie am Ball.
### 6. Von nix, kimmt nix!
Trainieren Sie ins Versagen, essen Sie Proteine, schlafen Sie genug! Das sind 97% des Erfolgs.
Alles andere ist marginal vom Impact.
`,
  },
  {
    id: 4,
    title: "Verursacht Kreatin Haarausfall?",
    excerpt: "Eine neue Studie, veröffentlicht im „Journal of the International Society of Sports Nutrition“ sieht das anders.",
    date: "2025-04-15",
    author: "I.Ey",
    content: `**Verursacht Kreatin Haarausfall? Wissenschaft entlarvt einen Mythos**

Eine neue Studie, veröffentlicht im „Journal of the International Society of Sports Nutrition“, hat direkt getestet, ob Kreatin-Supplementation den DHT-Spiegel oder das Risiko von Haarausfall beeinflusst. Über einen Zeitraum von 12 Wochen untersuchten die Forscher die Hormonprofile, Haardichte und Wachstumsmuster bei Männern, die Kreatin oder ein Placebo einnahmen, während sie Widerstandstraining durchführten. Die Ergebnisse zeigten keine signifikanten Unterschiede zwischen den beiden Gruppen und widerlegten somit einen langjährigen Mythos in der Fitness-Community.

**Was macht diese Studie so besonders?** Sie hat nicht nur Spekulationen über Hormone, sondern konkrete Ergebnisse zur Haargesundheit gemessen. Frühere Befürchtungen basierten auf einer kleinen Studie, die lediglich den DHT-Spiegel betrachtete, ohne tatsächlichen Haarausfall zu untersuchen. Die neue Forschung verfolgte einen umfassenden klinischen Ansatz und stellte fest, dass Kreatin-Supplementation keine messbaren Auswirkungen auf Haaranzahl, Aktivität der Haarfollikel oder Haarausfallzyklen hatte. Für Sportler, die sich Sorgen um ihre Haarlinie machen, bietet diese Studie wissenschaftliche Beruhigung.

Die zentrale Lektion: Die stärksten Werkzeuge im Fitnessbereich sind oft durch jahrzehntelange Forschung gestützt — nicht durch Gerüchte. Kreatin bleibt eines der sichersten und effektivsten Nahrungsergänzungsmittel, um Kraft, Leistung und Muskelwachstum zu unterstützen.

> „Does Creatine Cause Hair Loss? A 12-Week Randomized Controlled Trial“, veröffentlicht im Journal of the International Society of Sports Nutrition DOI: 10.1080/15502783.2025.2495229`
  }
];